<template>
  <v-main>
    <v-container fluid>
      <v-toolbar class="elevation-0">
        <v-toolbar-title class="pl-0">Clientes</v-toolbar-title>
        <v-spacer></v-spacer>
        <div class="d-flex mr-n4 align-center">
          <quicksearch v-model="quicksearch"></quicksearch>
          <v-btn text color="primary" @click="modalFilter = true">
            <v-icon left>mdi-filter-outline</v-icon> Filtrar
          </v-btn>
          <v-btn text color="primary" :to="{ name: 'customerFormNew' }">
            <v-icon left>mdi-plus-circle-outline</v-icon> Adicionar
          </v-btn>
        </div>
      </v-toolbar>
      <v-data-table
        :footer-props="{ itemsPerPageOptions: [10, 20, 30] }"
        :headers="headers"
        :items="items"
        :items-per-page.sync="pagination.rowsPerPage"
        :loading="loading"
        :no-data-text="noResultText"
        :no-results-text="noResultText"
        :page.sync="pagination.page"
        :server-items-length="pagination.total"
        :sort-by.sync="pagination.sortBy"
        :sort-desc.sync="pagination.sortDesc"
        loading-text="Carregando..."
      >
        <template v-slot:item.actions="{ item }">
          <v-btn :to="{ name: 'customerDetails', params: { id: item.id } }" color="primary" fab text small dark>
            <v-icon>mdi-file-find</v-icon>
          </v-btn>
          <v-btn :to="{ name: 'customerForm', params: { id: item.id } }" color="primary" fab text small dark>
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </template>
        <template v-slot:item.phone="{ item }">
          {{ item.phone | phone_number }}
        </template>
        <template v-slot:item.person_document="{ item }">
          {{ item.person_document | document }}
        </template>
        <template v-slot:item.joined_firebase="{ item }">
          {{ item.joined_firebase | boolean }}
        </template>
        <template v-slot:item.created_at="{ item }">
          {{ item.created_at | moment('DD/MM/YYYY hh:mm:ss') }}
        </template>
      </v-data-table>
    </v-container>
    <filter-modal :open="modalFilter" page="customers" title="Clientes" @close="modalFilter = false"></filter-modal>
  </v-main>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'

import Quicksearch from '@/components/Quicksearch'
import FilterModal from '@/components/FilterModal'

export default {
  components: {
    Quicksearch,
    FilterModal
  },
  data () {
    return {
      loading: false,
      modalFilter: false,
      quicksearch: '',
      headers: [
        { text: '', value: 'actions', sortable: false },
        { text: 'Nome', value: 'name' },
        { text: 'Apelido', value: 'nickname' },
        { text: 'Telefone', value: 'phone', sortable: false },
        { text: 'E-mail', value: 'email', sortable: false },
        { text: 'Documento pessoal', value: 'person_document', sortable: false },
        { text: 'Entrou no App', value: 'joined_firebase', sortable: false },
        { text: 'Cadastrado em', value: 'created_at' }
      ],
      items: [],
      pagination: {
        rowsPerPage: 20,
        page: 1,
        total: 0,
        sortBy: [],
        sortDesc: []
      }
    }
  },
  computed: {
    ...mapGetters(['searchParams']),
    noResultText () {
      return 'Nenhum usuário cadastrado'
    },
    params () {
      const quicksearch = this.quicksearch
      const { page, rowsPerPage } = this.pagination

      let params = ''

      params += `?page[size]=${rowsPerPage}`
      params += `&page[number]=${page}`

      if (quicksearch) params += `&filter[q]=${quicksearch}`

      for (let key in this.searchParams('customers')) {
        if (this.searchParams('customers')[key]) {
          if (Array.isArray(this.searchParams('customers')[key])) params += '&filter[' + key + ']=' + this.searchParams('customers')[key].join()
          else params += '&filter[' + key + ']=' + this.searchParams('customers')[key]
        }
      }

      for (let i = 0, l = this.pagination.sortBy.length; i < l; i++) {
        if (i === 0) params += '&sort='
        else params += ','
        if (this.pagination.sortDesc[i]) params += '-'
        params += this.pagination.sortBy[i]
      }

      return params
    }
  },
  watch: {
    params () {
      this.getData()
    }
  },
  methods: {
    getData () {
      this.loading = true
      this.items = []

      axios.get('customers' + this.params)
        .then(({ data }) => {
          this.items = data.data
          this.pagination.total = data.meta.total
        })
        .catch(() => {
          this.items = []
          this.pagination.total = 0
        })
        .finally(() => {
          this.loading = false
        })
    }
  },
  created () {
    this.getData()
  }
}
</script>
